import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "../../styles/open-pages/open-pages.css";
import "../../styles/pt/pt-trials.css";
import "../../styles/home/home.css";
import "../../styles/leave-management/leave-management.css";
import BackAddBtns from "../../components/Open-pages/target-matrics/common/BackAddBtns";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import StaffLeaveForm from "../../components/leave-management/staff/StaffLeaveForm";
import {
  fetchStaffLeaveStatsData,
  fetchStaffLeaveYearStats,
  fetchStaffLeavesData,
} from "../../redux/reducers/apiSlice";
import StaffLeaveDetTbFilters from "../../components/leave-management/admin/StaffLeaveDetTbFilters";
import {
  convertStraight,
  convertThenFormat,
} from "../../components/common-data/Converts";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { deleteAppliedLeave } from "../../data/ApiEndpoints";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
import HelmetWrapper from "../../HelmetWrapper";
import CommonMobTb from "../../components/leave-management/mobile-version/CommonMobTb";
import ViewLeavesMob from "../../components/leave-management/mobile-version/ViewLeavesMob";
import Notifications from "../../components/push-notifications/Notifications";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const StaffLeaveManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const { staffLeaves, staffLeaveStats, staffLeaveYearStats } = useSelector(
    (state) => state.api
  );

  const iniModValues = {
    isModOpen: false,
    leaveDetails: [],
    cardType: "",
    description: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isPage, setIsPage] = useState(0);
  const initialFilters = {
    selectedGym:
      !isAdmin && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.uid ||
              userInfoData?.user_id ||
              "",
          }
        : "",
    selectedOtherUsers: {
      label: userInfoData?.namee || "",
      value: userInfoData?.uid || userInfoData?.user_id || "",
    },
    selectedLeaveStatus: "",
    selectedStartDate: "",
    selectedEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    user_id: allFilters.selectedOtherUsers?.value || "",
    approval_status: allFilters.selectedLeaveStatus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    staffLeavesStats: {},
    staffLeavesYearStats: {},
    staffLeavesData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  const sortedStaffLeaveDetails =
    tbDatas.staffLeavesData?.length > 0
      ? [...tbDatas.staffLeavesData].sort((a, b) => {
          const dateA = new Date(a.leave_date);
          const dateB = new Date(b.leave_date);
          return dateB - dateA;
        })
      : [];

  const sortedLeaveDetails =
    modValues.leaveDetails?.length > 0
      ? [...modValues.leaveDetails].sort((a, b) => {
          const dateA = new Date(a.leave_date);
          const dateB = new Date(b.leave_date);
          return dateA - dateB;
        })
      : [];

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickModal = () => {
    setModValues((prevs) => ({ ...prevs, isModOpen: true, cardType: "add" }));
  };

  const handleDelete = async (filter) => {
    const handleConfirm = async () => {
      if (filter) {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteAppliedLeave,
              queryParams: filter,
            })
          ).unwrap();

          // console.log("response=> ", response);

          if (response?.status) {
            toast.success(response?.message || "Leave cancelled successfully!");
            getStaffLeaves();
            getStaffLeaveYearStats();
            getStaffLeaves();
          } else {
            toast.error(response?.message || "Can not cancelled leave!");
          }
        } catch (error) {
          toast.error(error || "Failed to cancelled leave");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(
      handleConfirm,
      `Are you sure, you want to cancelled this leave!`
    );
  };

  function getStaffLeaves() {
    dispatch(
      fetchStaffLeavesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getStaffLeaveStats() {
    const updatedFilters = {
      ...filters,
      filter_type: "category_sal_stats",
    };

    dispatch(
      fetchStaffLeaveStatsData({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  function getStaffLeaveYearStats() {
    const { start_date, end_date, ...restFilters } = filters;

    const updatedFilters = {
      ...restFilters,
      filter_type: "yearly_stats",
    };

    dispatch(
      fetchStaffLeaveYearStats({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym:
  //       userInfoData?.gym_id || userInfoData?.uid || userInfoData?.user_id
  //         ? {
  //             label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //             value:
  //               userInfoData?.gym_id ||
  //               userInfoData?.uid ||
  //               userInfoData?.user_id ||
  //               "",
  //           }
  //         : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: 10,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      user_id: allFilters.selectedOtherUsers?.value || "",
      approval_status: allFilters.selectedLeaveStatus?.value || "",
    }));
  }, [allFilters]);

  useEffect(() => {
    if (filters.user_id) {
      getStaffLeaveStats();
      getStaffLeaveYearStats();
      getStaffLeaves();
    }
  }, [filters]);

  useEffect(() => {
    if (staffLeaveStats?.status && staffLeaveStats?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesStats: staffLeaveStats.data?.[0],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesStats: {},
      }));
    }
  }, [staffLeaveStats]);

  useEffect(() => {
    if (staffLeaveYearStats?.status && staffLeaveYearStats?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesYearStats: staffLeaveYearStats.data?.[0],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesYearStats: {},
      }));
    }
  }, [staffLeaveYearStats]);

  useEffect(() => {
    if (staffLeaves?.status && staffLeaves?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesData: staffLeaves.data || [],
        pagination: staffLeaves?.pagination || [],
        staffLeaveStats: {},
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        staffLeavesData: [],
        pagination: [],
        staffLeaveStats: {},
      }));
    }
  }, [staffLeaves]);

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  // const location = useLocation();
  // const { decryptedText: userInfoData, isCustom } = location.state || {};
  // useEffect(() => {
  //   if (!userInfoData) {
  //     navigate("/open-access");
  //   }
  // }, [userInfoData]);

  const staffTbColumns = [
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        // const isDisbaled =
        //   row?.leave_dates_with_status?.length > 0
        //     ? row.leave_dates_with_status.some(
        //         (leave) => leave?.approval_status === 2
        //       )
        //     : false;
        const isDisbaled =
          row?.leave_dates_with_status?.length > 0
            ? row.leave_dates_with_status.every(
                (leave) => leave?.approval_status === 2
              )
            : false;

        const isDisbaledCancelBtn =
          row?.leave_dates_with_status?.length > 0
            ? row.leave_dates_with_status.some((leave) => {
                const leaveDate = new Date(leave.leave_date);
                const today = new Date();
                return leave?.approval_status === 1 && leaveDate < today;
              })
            : false;

        return (
          <div className="actionButtonContainer">
            <button
              type="button"
              className="actionBtn icon download"
              disabled={row?.required_doc}
              style={{
                cursor: row?.required_doc ? "pointer" : "not-allowed",
              }}
            >
              <a href={row?.required_doc}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-cloud-arrow-down"
                  viewBox="0 0 16 16"
                  style={{
                    color: row?.required_doc ? "#CD0909" : "gray",
                    width: "35px",
                    height: "35px",
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                  />
                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                </svg>
              </a>
            </button>

            <button
              type="button"
              className="actionBtn icon view"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardType: "view",
                  // leaveDetailsModal: true,
                  leaveDetails:
                    row?.leave_dates_with_status?.length > 0
                      ? row.leave_dates_with_status
                      : [],
                }))
              }
              style={{
                border:
                  row?.leave_dates_with_status?.length > 0
                    ? "1px solid #bc0909"
                    : "1px solid #9C9C9C",
                color:
                  row?.leave_dates_with_status?.length > 0
                    ? "#bc0909"
                    : "#9C9C9C",
                borderRadius: "12px",
                cursor:
                  row?.leave_dates_with_status?.length > 0
                    ? "pointer"
                    : "not-allowed",
              }}
              disabled={row?.leave_dates_with_status?.length === 0}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrows-angle-expand"
                viewBox="0 0 16 16"
                style={{
                  color:
                    row?.leave_dates_with_status?.length > 0
                      ? "#bc0909"
                      : "#9C9C9C",
                  width: "20px",
                  height: "20px",
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                />
              </svg>
            </button>

            <button
              type="button"
              className={`actionBtn txtBtn approve`}
              style={{
                color: isDisbaled ? "gray" : "",
                background: isDisbaled ? "lightgray" : "",
                cursor: isDisbaled ? "not-allowed" : "pointer",
              }}
              onClick={() =>
                !isDisbaled
                  ? setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardType: "edit",
                      rowData: row,
                    }))
                  : null
              }
              disabled={isDisbaled}
            >
              Edit
            </button>

            <button
              type="button"
              className={`actionBtn txtBtn reject`}
              style={{
                color: isDisbaled || isDisbaledCancelBtn ? "gray" : "",
                background:
                  isDisbaled || isDisbaledCancelBtn ? "lightgray" : "",
                cursor:
                  isDisbaled || isDisbaledCancelBtn ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                const uidFilter = {
                  user_id: row?.user_id || "",
                  apply_date: row?.apply_date || "",
                  leave_category_id: row?.leave_category_id || "",
                };
                handleDelete(uidFilter);
              }}
              disabled={isDisbaled || isDisbaledCancelBtn}
            >
              Cancel
            </button>
          </div>
        );
      },
    },
    {
      dataField: "apply_date",
      text: "Apply Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.apply_date ? convertStraight(row.apply_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "is_action_pending",
      text: "Approval Action",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_action_pending !== "true" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "matrix_status",
      text: "Leave Terms fulfilled",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.matrix_status === "matched" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "reporting_manager_name",
      text: "Approval Manager",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.reporting_manager_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.reporting_manager_mobile || ""}
              <br />
              {row?.reporting_manager_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "aprv_rej_by_name",
      text: "Approved/Rejected By",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.aprv_rej_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.aprv_rej_by_mobile || ""}
              <br />
              {row?.aprv_rej_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "leave_category_name",
      text: "leave category name",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background: "#157EF9",
              color: "#FFF",
              // background:
              //   row?.leave_category_name === "Sick Leave"
              //     ? "#FFF8C9"
              //     : "#DAFFFB",
              // color:
              //   row?.leave_category_name === "Sick Leave"
              //     ? "#F99417"
              //     : "#04364A",
            }}
          >
            {row?.leave_category_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "total_leave_days_approved",
      text: "Approved/Applied Leaves",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            <small
              style={{
                background: "#379C00",
                color: "#FFF",
                padding: "2px 10px",
                borderRadius: "4px",
              }}
            >
              {row?.total_leave_days_approved || 0}
            </small>{" "}
            /{" "}
            <small
              style={{
                background: "#BCBBF7",
                color: "#FFF",
                padding: "2px 10px",
                borderRadius: "4px",
              }}
            >
              {row?.total_leave_days_applied || 0}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "total_leave_days_applied",
    //   text: "total leave days applied",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">{row?.total_leave_days_applied || 0}</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "total_leave_days_approved",
    //   text: "total leave days approved",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">{row?.total_leave_days_approved || 0}</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "total_leave_days_used",
    //   text: "total leave days used",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">{row?.total_leave_days_used || 0}</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "total_leave_days_remaining",
    //   text: "total leave days remaining",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.total_leave_days_remaining || 0}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "total_leave_days_rejected",
    //   text: "Rejected Leaves",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">{row?.total_leave_days_rejected || 0}</span>
    //     );
    //   },
    // },
    {
      dataField: "is_paid",
      text: "Paid Leave",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_paid ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "doc_required",
      text: "doc required",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.doc_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "approval_required",
      text: "approval required",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.approval_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "days_before",
      text: "Max Leave(Monthly)",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.no_ofdays || 0} Day(S)</span>;
      },
    },
    {
      dataField: "days_before",
      text: "Apply Before",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.days_before || 0} Day(S)</span>;
      },
    },
    {
      dataField: "description",
      text: "Remarks",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row.description?.length <= 15 ? (
              row.description
            ) : row.description?.length >= 15 ? (
              <>
                {row.description?.substring(0, 15)}
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardType: "description",
                      description: row.description,
                    }))
                  }
                >
                  ...Read More
                </b>
              </>
            ) : (
              "NA"
            )}
            {/* {row?.description || "NA"} */}
          </span>
        );
      },
    },
    {
      dataField: "deducted_salary",
      text: "Deducted Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.deducted_salary || 0)}
          </span>
        );
      },
    },
  ];

  const leaveDetailsTbColumns = [
    {
      dataField: "leave_date",
      text: "Leave Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.leave_date ? convertStraight(row.leave_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "approval status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background:
                row?.approval_status === 1
                  ? "#DCECDC"
                  : row?.approval_status === 0
                  ? "#FFEDC0"
                  : "#F0E3E3",
              color:
                row?.approval_status === 1
                  ? "#209216"
                  : row?.approval_status === 0
                  ? "##171717"
                  : "#F13434",
            }}
          >
            {row?.approval_status === 1
              ? "Approved"
              : row?.approval_status === 0
              ? "Pending"
              : row?.approval_status === 2
              ? "Rejected"
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "aprv_rej_date",
      text: "Approve/Reject Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.aprv_rej_date ? convertStraight(row.aprv_rej_date) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Staff Leave Management System">
      <Container
        className="bg-cloud-k px-50px daily-target-metrics-container gobal-container"
        fluid
      >
        {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}

        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Leave Management Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardType === "add" || modValues.cardType === "edit"
                ? "apply-leave-form"
                : modValues.cardType === "description"
                ? "mod-width-50p"
                : ""
            }`}
          >
            <ModalHeadAndClose
              title={`${
                modValues.cardType === "add"
                  ? "Apply New Leave"
                  : modValues.cardType === "edit"
                  ? "Edit Applied Leave"
                  : modValues.cardType === "view"
                  ? "Leave Details"
                  : modValues.cardType === "description"
                  ? "Remarks"
                  : null
              }`}
              onClose={closeModal}
            />

            {modValues.cardType === "edit" || modValues.cardType === "add" ? (
              <StaffLeaveForm
                userInfoData={userInfoData}
                closeModal={closeModal}
                callFunction={() => {
                  getStaffLeaves();
                  getStaffLeaveYearStats();
                  getStaffLeaves();
                }}
                rowData={modValues.rowData}
                isEdit={modValues.cardType === "edit" ? true : false}
              />
            ) : modValues.cardType === "view" ? (
              <ViewLeavesMob
                tableData={sortedLeaveDetails}
                tbColumns={leaveDetailsTbColumns}
              />
            ) : modValues.cardType === "description" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.description || "No Content Available"}
                </p>
              </div>
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <WelcomeUser userName={userInfoData?.name} />
            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </Col>
        </Row>

        <Row>
          <Col>
            <BackAddBtns
              isCustom={isCustom}
              addBtnTxt={isCustom ? "Apply Leave" : ""}
              onClickAdd={isCustom ? onClickModal : null}
              onClickBack={isCustom ? handleBack : null}
              onClickReload={() => {
                getStaffLeaves();
                getStaffLeaveYearStats();
                getStaffLeaves();
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <StaffLeaveDetTbFilters
              userInfoData={userInfoData}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickReset={onClickReset}
              prevGymId={filters.gym_id}
              staffLeavesStats={tbDatas.staffLeavesStats}
              staffLeavesYearStats={tbDatas.staffLeavesYearStats}
              isNotAdmin={true}
              isLMStaffDate={true}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonMobTb
              tbData={sortedStaffLeaveDetails}
              tbColumns={staffTbColumns}
              tbPaignation={tbDatas.pagination}
              isPage={isPage}
              setIsPage={setIsPage}
              setModValues={setModValues}
              userInfoData={userInfoData}
              handleDelete={handleDelete}
              isStaff={true}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default StaffLeaveManagement;
